module.exports = __webpack_public_path__ + "img/invalidName@2x-2.8c25a103.png";